import { render, staticRenderFns } from "./TableRowdetailsSupport.vue?vue&type=template&id=08fa7872&"
import script from "./TableRowdetailsSupport.vue?vue&type=script&lang=js&"
export * from "./TableRowdetailsSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports